module.exports = __webpack_public_path__ + "img/login_dec03.95b126e1.png";